/**
 * L'Invoice project translations - Validation section
 */

const validation = {
  // General
  required: "Required",
  // Field-specific required messages
  businessNameRequired: "Business Name is required",
  contactPersonRequired: "Contact Person is required",
  emailRequired: "Email is required",
  addressRequired: "Address is required",
  taxNumberRequired: "Tax Number is required",
  postalCodeRequired: "Postal Code is required",
  cityRequired: "City is required",
  countryRequired: "Country is required",
  sendingMethodRequired: "Sending Method is required",
  peppolIdRequired: "Peppol ID is required",
  // Invalid format messages
  emailInvalid: "Email format is invalid",
  sendingMethodInvalid: "Sending Method is invalid",
  peppolIdInvalid: "Peppol ID is invalid",
  peppolIdMustContainColon: "Peppol ID must contain a colon (:)",
  peppolIdIncorrectlySpecified: "Peppol ID was incorrectly specified for customer",
  // Other validation
  invalidMethod: "Invalid method",
  attachmentsMaxCount: "You can attach up to 10 files.",
  attachmentsFilenameEmpty: "Each file must have a name.",
  attachmentsFilenameTooLong: "File names must be 255 characters or fewer.",
  attachmentsFilenameInvalidChars: "File names cannot contain / or \\.",
  attachmentsFilenameDuplicate: "File names must be unique.",
  attachmentsMimeNotAllowed: "This file type is not allowed. Use PDF, JPEG, PNG, CSV, XLSX, or ODS.",
  attachmentsTotalSize: "Total attachment size must stay within 99 MB after encoding.",
  attachmentsInvalidFile: "One or more selected files could not be used.",
  attachmentsHydrationFailed: "Existing attachments could not be loaded. Saving now would remove them from this invoice.",
};

export default validation;
